import React from 'react';

const INIT_STATE = {
  setting: {}
};


export default (state = INIT_STATE, action) => {

  switch (action.type) {

    case "TOGGLE_STATE": {
      return {
        ...state,
        toggle: action.payload
      };
    }
    case "CHANGE_VIEW": {
      return {
        ...state,
        view: action.payload
      };
    }
    case "CHANGE_PASSWORD": {
      return {
        ...state,
        isChangePasswordVisible: action.payload
      };
    }
    case "CONFIRMATION_DIALOG": {
      return {
        ...state,
        confirmationDialog: action.payload
      };
    }
    case "TIME_PICKER": {
      return {
        ...state,
        timePicker: action.payload
      };
    }
    case "TOGGLE_LOADER": {
      return {
        ...state,
        isLoading: action.payload
      };
    }

    case "TOGGLE_LOADER_MULTI": {
      var count = state.isLoadingCount;
      if (action.payload) {
        count++;
      }else {
        count--;
      }
      if (count <= 0) {
        return {
          ...state,
          isLoadingCount: 0,
          isLoading: false
        };
      }else {
        return {
          ...state,
          isLoadingCount: count,
          isLoading: true
        };
      }

    }


    default :
      return state;

  }
}

